import { AttachmentData, AttachmentDataWithRequiredAttachment, Attachment } from '../../../../../../../@types/types'

export const handleTitleChange = (
  attachment: AttachmentDataWithRequiredAttachment,
  setSelectedAttachmentsForEdit: React.Dispatch<React.SetStateAction<AttachmentDataWithRequiredAttachment[]>>,
  onAttachmentTitleChange: (attachment: AttachmentDataWithRequiredAttachment) => void
) => {
  setSelectedAttachmentsForEdit((prev) =>
    prev.map((att) => (att.attachment?.id === attachment.attachment?.id ? attachment : att))
  )
  onAttachmentTitleChange(attachment)
}

export const handleFloorPlanStatusChange = (
  attachment: AttachmentDataWithRequiredAttachment,
  setSelectedAttachmentsForEdit: React.Dispatch<React.SetStateAction<AttachmentDataWithRequiredAttachment[]>>,
  onAttachmentFloorPlanStatusChange: (attachment: AttachmentDataWithRequiredAttachment) => void
) => {
  setSelectedAttachmentsForEdit((prev) =>
    prev.map((att) => (att.attachment?.id === attachment.attachment?.id ? attachment : att))
  )
  onAttachmentFloorPlanStatusChange(attachment)
}

export const onAttachmentDeleteWithHandlingIndex = (
  attachment: Attachment,
  onAttachmentDelete: (attachment: Attachment) => void,
  currentIndex: number,
  attachmentsData: AttachmentData[],
  setCurrentIndex: (index: number) => void
) => {
  onAttachmentDelete(attachment)
  adjustCurrentIndexOnLastAttachmentDelete(currentIndex, attachmentsData, setCurrentIndex)
}

export function adjustCurrentIndexOnLastAttachmentDelete(
  currentIndex: number,
  attachmentsData: AttachmentData[],
  setCurrentIndex: (index: number) => void
) {
  if (currentIndex === attachmentsData.length - 1) {
    setCurrentIndex(currentIndex - 1)
  }
}

export const createNavigationFunctions = (
  currentIndex: number,
  setIndex: (fn: (prev: number) => number) => void,
  totalLength: number
) => {
  const showPrevious = currentIndex > 0
  const showNext = currentIndex < totalLength - 1
  const goPrevious = () => setIndex((prev) => Math.max(0, prev - 1))
  const goNext = () => setIndex((prev) => Math.min(totalLength - 1, prev + 1))

  return { showPrevious, showNext, goPrevious, goNext }
}
